var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as GC from "inputman.richtexteditor";
import { GcInputManComponents } from "./GcRichTextEditorBase";
var GcRichTextEditor = /** @class */ (function (_super) {
    __extends(GcRichTextEditor, _super);
    function GcRichTextEditor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GcRichTextEditor.prototype.initGcComponent = function (container) {
        var div = document.createElement(!!this.props.inline ? "div" : "textarea");
        if (this.props.elementId) {
            div.id = this.props.elementId;
        }
        div.innerHTML = container.innerHTML;
        container.innerHTML = "";
        container.appendChild(div);
        this.setElementName(div);
        var richtextEditor = new GC.InputMan.GcRichTextEditor(div, this.props);
        if (typeof this.props.onInitialized === "function") {
            this.props.onInitialized(richtextEditor);
        }
        return richtextEditor;
    };
    GcRichTextEditor.prototype.bindEvent = function () {
        var _this = this;
        this._imCtrl.addEventListener(GC.InputMan.GcRichTextEditorEvent.SelectionChange, function (s, args) {
            if (typeof _this.props.selectionChange === "function") {
                _this.props.selectionChange(s, args);
            }
        });
        this._imCtrl.addEventListener(GC.InputMan.GcRichTextEditorEvent.AfterExecCommand, function (s, args) {
            if (typeof _this.props.afterExecCommand === "function") {
                _this.props.afterExecCommand(s, args);
            }
        });
        this._imCtrl.addEventListener(GC.InputMan.GcRichTextEditorEvent.BeforeExecCommand, function (s, args) {
            if (typeof _this.props.beforeExecCommand === "function") {
                _this.props.beforeExecCommand(s, args);
            }
        });
        this._imCtrl.addEventListener(GC.InputMan.GcRichTextEditorEvent.Focus, function (s, args) {
            if (typeof _this.props.focus === "function") {
                _this.props.focus(s, args);
            }
        });
        this._imCtrl.addEventListener(GC.InputMan.GcRichTextEditorEvent.Blur, function (s, args) {
            if (typeof _this.props.blur === "function") {
                _this.props.blur(s, args);
            }
        });
        this._imCtrl.addEventListener(GC.InputMan.GcRichTextEditorEvent.Copy, function (s, args) {
            if (typeof _this.props.copy === "function") {
                _this.props.copy(s, args);
            }
        });
        this._imCtrl.addEventListener(GC.InputMan.GcRichTextEditorEvent.Cut, function (s, args) {
            if (typeof _this.props.cut === "function") {
                _this.props.cut(s, args);
            }
        });
        this._imCtrl.addEventListener(GC.InputMan.GcRichTextEditorEvent.Paste, function (s, args) {
            if (typeof _this.props.paste === "function") {
                _this.props.paste(s, args);
            }
        });
        this._imCtrl.addEventListener(GC.InputMan.GcRichTextEditorEvent.KeyDown, function (s, args) {
            if (typeof _this.props.keyDown === "function") {
                _this.props.keyDown(s, args);
            }
        });
        this._imCtrl.addEventListener(GC.InputMan.GcRichTextEditorEvent.KeyPress, function (s, args) {
            if (typeof _this.props.keyPress === "function") {
                _this.props.keyPress(s, args);
            }
        });
        this._imCtrl.addEventListener(GC.InputMan.GcRichTextEditorEvent.KeyUp, function (s, args) {
            if (typeof _this.props.keyUp === "function") {
                _this.props.keyUp(s, args);
            }
        });
        this._imCtrl.addEventListener(GC.InputMan.GcRichTextEditorEvent.Init, function (s, args) {
            if (typeof _this.props.init === "function") {
                _this.props.init(s, args);
            }
        });
    };
    GcRichTextEditor.prototype.destroyGcComponent = function (container) {
        var _a;
        (_a = this._imCtrl) === null || _a === void 0 ? void 0 : _a.destroy();
        container.innerHTML = "";
    };
    return GcRichTextEditor;
}(GcInputManComponents));
export { GcRichTextEditor };
